import { useSafeWorkflow } from '../workflow/hooks';
import { ClientError } from 'graphql-request';

export type ErrorCode = 'UNAUTHORIZED' | string;

const getErrorCode = (error: unknown): ErrorCode | undefined => {
  if (error instanceof ClientError) {
    const firstError = error.response.errors?.[0];
    if (firstError?.extensions?.code) {
      return firstError.extensions.code as ErrorCode;
    }
  }

  return undefined;
};

export const useErrorHandler = () => {
  const workflow = useSafeWorkflow();

  return (error?: unknown): void => {
    if (!error) return;
    const code = getErrorCode(error);

    switch (code) {
      case 'UNAUTHORIZED':
        if (!workflow?.requestId) {
          workflow?.logout();
        }
        return;

      default:
        return;
    }
  };
};
